import React, { Fragment, useEffect, useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import { useHistory } from "react-router-dom";
import Loader from "../../components/Loading/loading";

import user from "../../static/images/user_default.png";
import { ListItemIcon } from "@material-ui/core";
import useMediaQuery from "../../Hooks/useMediaQuery";

function Carousel({ id, qty, titulo }) {
  const [currentPage, setcurrentPage] = useState(2);
  const [list, setdata] = useState([]);
  const [indicators, setindicators] = useState([]);
  const [info, setinfo] = useState([]);
  const [filtered, setfiltered] = useState("");
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState({
    nombre: "",
  });
  const isMobile = useMediaQuery("(max-width: 927px)");

  let history = useHistory();

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      GenerateItems();
    }, 700);

    return () => clearTimeout(delayDebounceFn);
  }, [search]);

  const GenerateItems = async () => {
    let arr = [];
    for (let i = 0; i <= 2; i++) {
      let data = await GetData(
        i,
        isMobile ? 1 : 3,
        validateSearchString(search.nombre)
      ); //servicio requiere reemplazar los espacios por el caracter '|'
      // ????? que decisión de diseño tan mierda

      if (data != undefined) {
        if (data.length > 0) {
          let item = (
            <div
              key={id + "carousel_" + Math.floor(Math.random() * 1000)}
              data-bs-interval="1000000"
              className={i == 0 ? "carousel-item active" : "carousel-item"}
            >
              {data.map((item, idex) => {
                return (
                  <div
                    key={idex + "_" + item.aplicanteId}
                    className="card-item"
                    style={{ minWidth: isMobile ? "80%" : "" }}
                  >
                    <div className="card">
                      <div className="mt-4 box-imgCat">
                        <img src={item.photo != null ? item.photo : user}></img>
                      </div>
                      <div className="card-body">
                        <h5 className="mb-5 card-title">
                          {item.nombre} {item.apellido}
                        </h5>
                        <p
                          className="mb-5  card-text"
                          style={{ marginBottom: "5rem !important" }}
                        >
                          {item.profesion}
                        </p>
                        <div className="mt-4 mb-4 badges">
                          <h6>
                            Grupos:<span className="badge">-</span>
                          </h6>
                          <h6>
                            Insignias:<span className="badge">-</span>
                          </h6>
                        </div>
                        <hr></hr>
                        <button
                          className="mt-4 mb-2 btn btn-info"
                          onClick={() => setLink(item.aplicanteId)}
                        >
                          Ver perfil
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          );
          arr.push(item);
        }
        i = data.length < 3 ? 2 : i;
      }
    }
    setinfo(arr);
    setLoading(false);
  };

  const GetData = async (page, paginate, nombre) => {
    try {
      setLoading(true);
      const data = await axios({
        method: "post",
        url: `access/find-applicants-paged?pageNo=${page}&pagesize=${paginate}`,
        data: {
          nombre: nombre,
          apellido: "",
        },
      }).then((result) => {
        return result;
      });
      return data.data.content;
    } catch (error) {}
  };

  const NextPageNew = async () => {
    if (currentPage > 2) {
      let arr = info;
      let data = await GetData(currentPage, isMobile ? 1 : 4, search.nombre);
      if (data.length > 0) {
        let item = (
          <div
            key={id + "carousel_" + Math.floor(Math.random() * 1000)}
            data-bs-interval="1000000"
            className="carousel-item"
          >
            {data.map((item, idex) => {
              // console.log("MAP IDEX: " + idex);
              return (
                <div
                  key={idex + "_" + item.aplicanteId}
                  className="card-item"
                  style={{ minWidth: isMobile ? "80%" : "" }}
                >
                  <div className="card">
                    <div className="mt-4 box-imgCat">
                      <img src={item.photo != null ? item.photo : user}></img>
                    </div>
                    <div className="card-body">
                      <h5 className="mb-5 card-title">
                        {item.nombre} {item.apellido}
                      </h5>
                      <p className="mb-5 card-text">{item.profesion}</p>
                      <hr></hr>
                      <div className="mt-4 mb-4 badges">
                        <h6>
                          Grupos:<span className="badge">-</span>
                        </h6>
                        <h6>
                          Insignias:<span className="badge">-</span>
                        </h6>
                      </div>
                      <hr></hr>
                      <button
                        className="mt-4 mb-2 btn btn-info"
                        onClick={() => setLink(item.aplicanteId)}
                      >
                        Ver perfil
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        );
        // setcurrentPage(currentPage + 1);
        arr.push(item);
        setinfo(arr);
      }
      setLoading(false);
    }
  };

  function LoadIndicators(data) {
    let arr = [];

    for (let index = 0; index <= data; index++) {
      let btn = (
        <button
          key={index}
          type="button"
          data-bs-target={"#carousel" + id}
          data-bs-slide-to={"" + index + ""}
          aria-label={"Slide " + (index + 1)}
          className={index == 0 ? "active" : ""}
        ></button>
      );
      arr.push(btn);
    }
    setindicators(arr);
  }

  function setLink(item) {
    let rol = localStorage.getItem("rol");
    let path;
    let state;
    switch (rol) {
      case "applicant":
        history.push({
          pathname: "/user/Candidato/",
          state: { userid: item },
        });
        break;
      case "company":
        history.push({
          pathname: "/company/Candidato/",
          state: { userid: item },
        });
        break;
      case "institute":
        history.push({
          pathname: "/CentroFormacion/Candidato",
          state: { userid: item },
        });
        break;
    }
  }
  var controladorTiempo = "";
  const Search = (e) => {
    let { value } = e.target;

    // clearTimeout(controladorTiempo);
    setSearch({ ...search, nombre: value });
    // controladorTiempo = setTimeout(GenerateItems(), 5000);
    // console.log(controladorTiempo);
  };

  const validateSearchString = (data) => {
    let str = data.replaceAll(" ", "|");
    str = str.trim().replaceAll("||||", "|");
    str = str.trim().replaceAll("|||", "|");
    str = str.trim().replaceAll("||", "|");

    if (str.slice(-1) === "|") {
      return str.substring(0, str.length - 1);
    } else return str;
  };

  const sty = {
    display: "none",
  };

  return (
    <Fragment>
      <div className="row mt-2 mb-4">
        <div className="col-12 col-md-6">
          <div className="p-2 bordered-box__header-title">
            <span className="align-middle ">{titulo}</span>
          </div>
        </div>
        <div className="col-12 col-md-6 text-end">
          <div className="search">
            <i className="fas fa-search"></i>
            <input
              type="text"
              placeholder="Buscar"
              onChange={(e) => Search(e)}
            ></input>
          </div>
        </div>
      </div>
      <div className={loading ? "loader_container" : "center-panel"}>
        {loading ? <Loader type="small"></Loader> : ""}
        <div
          id={"carousel" + id}
          className={loading ? "carousel-none" : "carousel slide"}
          data-interval="false"
        >
          <div className="carousel-inner">
            {!filtered.length > 0 ? info : filtered}
          </div>
          <button
            className="carousel-control-prev"
            // style={sty}
            type="button"
            data-bs-target={"#carousel" + id}
            data-bs-slide="prev"
          ></button>
          <button
            className="carousel-control-next"
            type="button"
            data-bs-target={"#carousel" + id}
            data-bs-slide="next"
            onClick={() => {
              setcurrentPage(currentPage + 1);
              NextPageNew();
            }}
          ></button>
        </div>
        {/* )} */}
      </div>
    </Fragment>
  );
}

export default Carousel;
